import { api } from './client'

export interface TeamMember {
  id: string
  fullName: string
  email: string
  /** A team lead sees the records of everyone in the team. A team may have several. */
  lead: boolean
}

export interface Team {
  id: string
  name: string
  members: TeamMember[]
  createdAt: string
  updatedAt: string
}

/** Create/update payload. Leads are set per member via {@link setTeamLead}. */
export interface TeamInput {
  name: string
}

export async function listTeams(): Promise<Team[]> {
  return (await api.get<Team[]>('/api/teams')).data
}

export async function createTeam(input: TeamInput): Promise<Team> {
  return (await api.post<Team>('/api/teams', input)).data
}

export async function updateTeam(id: string, input: TeamInput): Promise<Team> {
  return (await api.put<Team>(`/api/teams/${id}`, input)).data
}

export async function deleteTeam(id: string): Promise<void> {
  await api.delete(`/api/teams/${id}`)
}

export async function addTeamMember(teamId: string, userId: string): Promise<Team> {
  return (await api.post<Team>(`/api/teams/${teamId}/members`, { userId })).data
}

export async function removeTeamMember(teamId: string, userId: string): Promise<void> {
  await api.delete(`/api/teams/${teamId}/members/${userId}`)
}

/** Flag/unflag a member as a team lead (a team may have several). */
export async function setTeamLead(teamId: string, userId: string, lead: boolean): Promise<Team> {
  return (await api.put<Team>(`/api/teams/${teamId}/members/${userId}/lead`, { lead })).data
}
